<div>
  <i class="fa fa-spin fa-spinner"
     *ngIf="!subscriptionManageForm">
  </i>
    <!--to {{apiDetail?.displayName}}-->
  <form class="condensed mb-2"
        *ngIf="subscriptionManageForm"
        [formGroup]="subscriptionManageForm"
        (keyup.enter)="onSubmit()"
        (ngSubmit)="onSubmit()">
    <h2>
      {{title}}
    </h2>
      <!--<p>Form value: {{ subscriptionManageForm.value | json }}</p>-->
    <div *ngIf="isSubscribing">
      <a class="aqx-expand-collapse"
         data-toggle="collapse"
         data-target="#advancedModeContainer"
         aria-expanded="false"
         aria-controls="advancedModeContainer">
          Advanced Options
      </a>
      <div class="collapse card-body" id="advancedModeContainer">
        <div class="form-group"
             *ngFor="let applicationCreationTypeItem of applicationCreationTypes | keyvalue; let idx = index">
          <div class="form-inline">
            <div class="form-check">
              <input id="item{{idx}}"
                     class="form-check-input"
                     type="radio"
                     formControlName="applicationCreationTypeSelected"
                     [value]="applicationCreationTypeItem.value">
              <label for="item{{idx}}"
                     class="form-check-label col-form-label-sm">
                Subscribe within {{applicationCreationTypeItem.value.label}}
              </label>
            </div>
            <select id="applicationExistingSelected"
                    class="form-control form-control-sm ml-2"
                    *ngIf="subscriptionManageForm.value.applicationCreationTypeSelected === applicationCreationTypes.applicationExisting && applicationCreationTypeItem.value === applicationCreationTypes.applicationExisting"
                    formControlName="applicationExistingSelected">
              <option *ngFor="let application of applications.list"
                      [ngValue]="application">
                {{application.name}}
              </option>
            </select>
          </div>
          <div formGroupName="applicationNew"
               *ngIf="subscriptionManageForm.value.applicationCreationTypeSelected === applicationCreationTypes.applicationNew && applicationCreationTypeItem.value === applicationCreationTypes.applicationNew"
            class="ml-4 mt-2">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label-sm"
                     for="applicationName">
                Name
              </label>
              <div class="col-sm-10">
                <input id="applicationName"
                       class="form-control form-control-sm"
                       type="text"
                       formControlName="applicationName"
                       required>
                <!--placeholder="Name of OAuth 2.0 application"-->
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label-sm"
                     for="applicationDescription">
                Description
              </label>
              <div class="col-sm-10">
                <input id="applicationDescription"
                       class="form-control form-control-sm"
                       type="text"
                       formControlName="applicationDescription">
                <!--placeholder="Description for OAuth 2.0 application"-->
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label-sm"
                     for="applicationCallbackUrl">
                Callback URL
              </label>
              <div class="col-sm-10">
                <input id="applicationCallbackUrl"
                       class="form-control form-control-sm"
                       type="text"
                       formControlName="applicationCallbackUrl"
                       aria-describedby="applicationCallbackUrlHelpBlock">
                <small id="applicationCallbackUrlHelpBlock"
                       class="form-text text-muted">
                  OAuth 2.0 Callback URL used for OpenID Connect.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix ml-5">
      <!--<div xclass="float-right">-->
        <button class="btn btn-light"
                (click)="cancel()">
          Cancel
        </button>
        <button class="btn btn-primary"
                type="submit">
          {{title}}
        </button>
      <!--</div>-->
    </div>
  </form>
</div>
